export class ConfigService {
  private static configService: ConfigService;
  private issuer: string;
  private clientId: string;
  private logoutUrl: string;

  private constructor() {
    this.issuer = '';
    this.clientId = '';
    this.logoutUrl = '';
  }

  public static getInstance() {
    if (!this.configService) {
      this.configService = new ConfigService();
    }
    return this.configService;
  }

  public getIssuer() {
    return this.issuer;
  }

  public getClientId() {
    return this.clientId;
  }

  public getLogoutUrl() {
    return this.logoutUrl;
  }

  public setConfig({
    issuer,
    clientId,
    logoutUrl,
  }: {
    issuer: string;
    clientId: string;
    logoutUrl: string;
  }) {
    this.issuer = issuer;
    this.clientId = clientId;
    this.logoutUrl = logoutUrl;
  }
}
